// CANONICAL COPY (GH #7115). src/constants/obligations/obl-regulatory-incident-notification.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-regulatory-incident-notification',
  title: 'Verify regulatory incident notification procedures',
  description:
    'Confirm that procedures exist for notifying competent authorities and CSIRTs of significant incidents within the NIS2 timelines: early warning within 24 hours of awareness, incident notification within 72 hours, and final report within one month. Verify notification records are retained.',
  category: 'incidents',
  scfIds: ['SCF-INC-006'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'Regulatory incident notification procedure is published',
    },
    { type: 'document-approved', description: 'Procedure has been approved' },
    { type: 'document-within-sla', description: 'Procedure review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
